import { Navigate, useParams } from 'react-router-dom'
import { applicationDetailPath, applicationsListPath } from '../../../utils/applicationRoutes'
import { ROUTES } from '../../../config/constants'

/** Письма и старые ссылки на /company/applications → SPA calculator. */
export const LegacyCompanyApplicationsRedirect = () => (
  <Navigate to={applicationsListPath()} replace />
)

export const LegacyCompanyApplicationDetailRedirect = () => {
  const { publicId = '' } = useParams()
  return <Navigate to={applicationDetailPath({ publicId: publicId })} replace />
}

/** Ссылки ui-kit на /company/orders/* → заявки с расчётов. */
export const LegacyOrdersListRedirect = () => (
  <Navigate to={applicationsListPath()} replace />
)

export const LegacyOrdersDetailRedirect = () => {
  const { publicId = '' } = useParams()
  return <Navigate to={applicationDetailPath({ publicId: publicId })} replace />
}

export const legacyOrdersListPattern = `${ROUTES.ORDERS}/${ROUTES.LIST}`
export const legacyOrdersDetailPattern = `${ROUTES.ORDERS}/:publicId`
